import { FC, Fragment } from "react";
import React from "react";
import { makeStyles, createStyles, FormControl, Grid } from "@material-ui/core";
import { FormControlLabel } from "../core/FormControlLabel";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { Checkbox } from "../core/Checkbox";
import { Colors } from "../../styles";
import { useStyles } from "../../useStyles";
const useFormControlStyle = makeStyles(() =>
    createStyles({
        container: {
            display: "flex",
            flexDirection: "row",
        },
        containerError: {
            backgroundColor: Colors.radiantRedFill,
            borderColor: Colors.radiantRed,
            borderStyle: "solid",
            borderWidth: "1px",
            borderRadius: 8,
        },
        formControlLabelStyle: {
            marginRight: 110,
        },
        checkboxStyle: {
            marginRight: 8,
        },
    }),
);

export const NewConnectionMultilinePersonalContributionMustDoWallBushingForm: FC = () => {
    const classes = useStyles();
    const { values, setValues } =
        useFormModel<ChangeNames.NEW_CONNECTION_MULTILINE_PERSONAL_CONTRIBUTION_MUST_DO_WALL_BUSHING>();
    const formControlClasses = useFormControlStyle();

    return (
        <Fragment>
            <FormControl
                component="fieldset"
                className={classes.container}
                style={{ display: "flex" }}
            >
                <Grid container spacing={7} className={formControlClasses.container}>
                    <Grid item>
                        <FormControlLabel
                            isCheckBox={true}
                            className={formControlClasses.formControlLabelStyle}
                            control={
                                <Checkbox
                                    className={formControlClasses.checkboxStyle}
                                    value="power"
                                    checked={
                                        values
                                            .newConnectionMultilinePersonalContributionMustDoWallBushing
                                            .value.yes
                                    }
                                    onChange={(event, checked) =>
                                        setValues((values) => {
                                            values.newConnectionMultilinePersonalContributionMustDoWallBushing.value.yes =
                                                checked;
                                            values.newConnectionMultilinePersonalContributionMustDoWallBushing.value.no =
                                                !checked;
                                        })
                                    }
                                />
                            }
                            label="Wanddurchführung"
                            sublabel="Die Wanddurchführung <b>muss</b> in Eigenleistung ausgeführt werden"
                            text="Entsprechend Ihrer Wandbeschaffenheit ist eine geeignete Wanddurchführung laut den Mindestanforderungen für die Erbringung von Eigenleistungen zu erbringen. Die Mindestanforderungen für die Erbringung von Eigenleistungen können Sie <a href='https://www.syna.de/content/dam/syna-de/dokumente/netzanschluss/weg-zum-netzanschluss/eigenleistungen-mindestanforderungen-syna-012015.pdf'>hier</a> als PDF Dokument herunterladen.<br/>Sofern ein Futterrohr verwendet wird, erfolgt das Einbringen des Futerrohrs in die Wand vor dem Installationstermin durch Auftraggeber.<br/>KG-Rohre oder andere Kunstoffrohre sind nicht zugelassen"
                            error={
                                values.newConnectionMultilinePersonalContributionMustDoWallBushing
                                    .error !== null
                            }
                        />
                    </Grid>
                </Grid>
            </FormControl>
        </Fragment>
    );
};
